import script from "./NativeCloudPhonePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./NativeCloudPhonePreview.vue?vue&type=script&setup=true&lang=js"

import "./NativeCloudPhonePreview.vue?vue&type=style&index=0&id=6bb576ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb576ca"]])

export default __exports__